import { CommonModal } from "components";
import { idfcMultiPayment } from "_services";
import { useAccountList, useAuthFlow } from "hooks";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

const IDFCBankAccountModal = (props) => {
  const { paymentList, handlePaymentAprovel,currentVoucher } = props;

  const inputRefs = useRef([]);
  const [globalLoading, setGlobalLoading] = useState(false);
  const [paymentMode, setPaymentMode] = useState(null);
  const { accounts, loading, refresh, setAccounts } = useAccountList({
    autoFetch: false,
  });

useEffect(() => {
  if (
    !accounts || 
    !accounts.sub_category || 
    !Array.isArray(accounts.sub_category) || 
    !currentVoucher?.cb_account_id
  ) {
    return;
  }

  setAccounts((prev) => {
    if (!prev?.sub_category || !Array.isArray(prev.sub_category)) return prev;

    return {
      ...prev,
      sub_category: prev.sub_category.map((sub) =>
        sub.id === 27
          ? {
              ...sub,
              accounts: sub.accounts?.filter(
                (acc) => acc?.cb_account_id == currentVoucher.cb_account_id
              ) || [],
            }
          : sub
      ),
    };
  });
}, [loading,currentVoucher?.cb_account_id]);

  const [selectedAcc, setSelectAcc] = useState(null);
  const [otp, setOtp] = useState(["", "", "", "", ""]);
  const [otpError, setOtpError] = useState(false);
  const [timer, setTimer] = useState(59);
  const [isVerify, setIsVerify] = useState(false);
  const [otpSend, setOtpSend] = useState(false);
  const [paymentRef, setPaymentRef] = useState("");

  const fetchOtp = async (item, auth_token, data) => {
    
    setAccounts((prev) => ({
      ...prev,
      sub_category: prev.sub_category.map((sub) =>
        sub.id === 27
          ? {
              ...sub,
              accounts: sub.accounts.map((acc) =>
                acc.cb_data?.referenceNumber === item?.referenceNumber
                  ? {
                      ...acc,
                      cb_data: {
                        ...acc.cb_data,
                        auth_token: data?.auth_token || auth_token,
                        auth_token_expires_at:
                          data?.auth_token_expires_at ||
                          item?.auth_token_expires_at,
                        auth_token_generated_at:
                          data?.auth_token_generated_at ||
                          item?.auth_token_generated_at,
                        auth_token_updated_at:
                          data?.auth_token_updated_at ||
                          item?.auth_token_updated_at,
                      },
                    }
                  : acc
              ),
            }
          : sub
      ),
    }));

    setSelectAcc((prev) =>
      prev && prev.cb_data?.referenceNumber === item?.referenceNumber
        ? {
            ...prev,
            cb_data: {
              ...prev.cb_data,
              auth_token: data?.auth_token || auth_token,
              auth_token_expires_at:
                data?.auth_token_expires_at || item?.auth_token_expires_at,
              auth_token_generated_at:
                data?.auth_token_generated_at || item?.auth_token_generated_at,
              auth_token_updated_at:
                data?.auth_token_updated_at || item?.auth_token_updated_at,
            },
          }
        : prev
    );

    setGlobalLoading(true);
    let a_id = selectedAcc?.cb_data?._id || item?._id

    let list = currentVoucher && currentVoucher?._id ? 

    [currentVoucher._id] 
    // : paymentList.map((item) => item._id);
    :paymentList
      .filter(
        (item) =>
          item.cb_account_id === a_id
      )
      .map((item) => item._id);

    try {
      const param = {
        access_token: `Bearer ${
          auth_token || data?.auth_token || item.auth_token
        }`,
        otp: otp.join(""),
        voucher_ids: list,
        payment_mode:paymentMode,
        from_account_id: selectedAcc?.cb_data?._id || item?._id,
        ...(paymentRef ? { payment_ref_id: paymentRef } : {}),
      };

      const res = await idfcMultiPayment(param);

      if (res?.data?.code == "402" || res?.responseCode == 402) {
        fetchWithAuth(selectedAcc?.cb_data || item, true);
        return;
      }

      if (res?.status && res?.data?.errorCode === "OTPREQ01") {
        setPaymentRef(res?.data?.payment_ref_id);
        setOtpSend(true);
        setTimer(59);
        setOtp(["", "", "", "", ""]);
      } else if (
        res?.status &&
        res?.data?.errorCode === "" &&
        res?.data?.status === "Success"
      ) {
        toast.success(res?.message || "Success");
        setPaymentRef("");
        setOtpSend(false);
        setTimer(59);
        setOtp(["", "", "", "", ""]);
        setSelectAcc(null);
        handlePaymentAprovel();
        props.closeModal();
      } else if (res?.status && res?.data?.errorCode === "CHB002") {
        toast.error(res.message || res?.data?.errorMessage);
      } else {
        toast.error("Something went wrong.");
        return null;
      }
    } catch (error) {
      console.error("Error:", error);
      return null;
    } finally {
      setGlobalLoading(false);
    }
  };

  const { fetchWithAuth } = useAuthFlow(fetchOtp);

  useEffect(() => {
    refresh();
  }, []);

  const handleFocus = (e) => {
    e.target.select();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const updatedOtp = [...otp];
      if (otp[index]) {
        updatedOtp[index] = "";
      } else if (index > 0) {
        inputRefs.current[index - 1].focus();
        updatedOtp[index - 1] = "";
      }
      setOtp(updatedOtp);
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (index === otp.length - 1) {
        fetchOtp(selectedAcc?.cb_data, selectedAcc?.cb_data?.auth_token);
      }
    }
  };

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d{0,1}$/.test(value)) {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);
      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  return (
    <div>
      <CommonModal {...props}>
        <div className="_selectLrBody">
          <div className="_selectLr_tabl">
            {globalLoading && (
              <div
                class="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 text-white"
                style={{ zIndex: 1000, background: "rgba(0,0,0,0.8)" }}
              >
                <div>...Please wait</div>
              </div>
            )}

        

            {!otpSend && (
              <div>

{!loading && accounts && 
        <div className="flex justify-center items-center py-2">
              <label>
                <input  type="radio" name="paymentMode" id="neft" value="1"
                  checked={paymentMode === 1}
                  onChange={() => setPaymentMode(1)}
                />
                {" "}NEFT
              </label>
            {" "}
              <label>
                <input type="radio" name="paymentMode" id="imps" value="2"
                  checked={paymentMode === 2}
                  onChange={() => setPaymentMode(2)}
                />
                {" "}IMPS
              </label>
            </div>}
            
                {loading ? (
                  <p className="text-center">fetching accounts...</p>
                ) : accounts && paymentMode ? (
                  <div className="_trancMain_bx">
                    {accounts?.sub_category?.map((i, index) => {
                      return (
                        <React.Fragment key={index}>
                          {i?.id == 27 ? (
                            <div
                              className="container-fluid"
                              key={`${i.id}_${i?.name}`}
                            >
                              <h4 className="_trancHead">{i?.name}</h4>

                              <div className="row cashInHnad_s">
                                {i?.accounts?.map((k) => {
                                  return (
                                    <React.Fragment>
                                      {k?.cb_account_type == 1 && k?.cb_data ? (
                                        <div
                                          className="col-md-6 col-lg-4 col-xl-3"
                                          key={`${i.id}_${i?.name}_${k?.name}`}
                                        >
                                          <div
                                            className={`branch_inner`}
                                            onClick={() => {
                                              if ( selectedAcc && selectedAcc?._id == k?._id) {
                                                setSelectAcc(null);
                                              } else {
                                                //   handleAccount(k);
                                                setSelectAcc(k);
                                                if (k?.cb_data) {
                                                  fetchWithAuth(k.cb_data);
                                                } else {}
                                              }
                                            }}
                                            style={selectedAcc?._id === k._id ? {borderColor: "var(--buttonBg)"}: {}}
                                          >
                                            <div className="branch_left">
                                              <div>
                                                <h6>IDFC First Bank</h6>
                                                <span className="__accNumber">
                                                  {k?.cb_data?.account_name}
                                                </span>
                                                <span className="__accNumber">
                                                  {k?.cb_data?.account_number}
                                                </span>
                                                <p
                                                  className={`__accStatus  ${k?.cb_data?.status == 1 ? "__accActive_sts" : "__accActive_sts" }`}
                                                >
                                                  <span></span>{" "}
                                                  {k?.cb_data?.status == 1 ? "Active" : k?.cb_data?.status == 0 ? "Pending" : ""}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="branch_right"></div>
                                          </div>
                                        </div>
                                      ) : null}
                                    </React.Fragment>
                                  );
                                })}
                              </div>
                            </div>
                          ) : null}
                        </React.Fragment>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            )}

            {otpSend && (
              <div>
                <div className="_subFrm_fx">
                  <div className="_baseInput_bx ">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px",
                      }}
                    >
                      {otp.map((digit, index) => (
                        <input
                          type="tel"
                          key={index}
                          className="__mobPin_input"
                          value={digit}
                          onChange={(e) => handleChange(e, index)}
                          onFocus={handleFocus}
                          maxLength={1}
                          required
                          ref={(el) => (inputRefs.current[index] = el)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                        />
                      ))}
                    </div>
                  </div>

                  {otpError && (
                    <small className="text-danger">{otpError}</small>
                  )}

                  <div className="d-flex justify-content-center">
                    <button
                  style={{width:'200px'}}
                    className="anime-btn _submitOn_board"
                    type="submit"
                    disabled={isVerify}
                    onClick={() =>
                      fetchOtp(
                        selectedAcc?.cb_data,
                        selectedAcc?.cb_data?.auth_token
                      )
                    }
                  >
                    {isVerify ? "Verifying..." : "Submit OTP"}{" "}
                  </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </CommonModal>
    </div>
  );
};

export default IDFCBankAccountModal;
